
<div>
    <div class="banner-admin-only mx-4">
        <span class="mdi mdi-information-outline"></span> <span>Schedule Reports page is restricted to <b>Admin</b> users Only</span>
    </div>
    <div class="p-4 scheduled-report-page" data-app="true">
    <div :style="scheduledReportBanner.isShow ? 'bottom: 0;' : 'bottom: -10rem;'"
        :class="scheduledReportBanner.class" class="report-banner" style="z-index: 51;">
        <div class="d-flex align-items-center"><b>{{ scheduledReportBanner.text }}</b></div>
    </div>
    
    <div class="">
        <h4 class="text-capitalize ma-0 font-weight-bold" style="margin-bottom: 16px;">Scheduled Reports</h4>
        <p class="ma-0">Create exports from any report template, choose when to send them, and we deliver them automatically. Schedule reports weekly or monthly, and select recipients to ensure the right people receive the right data.</p>
    </div>
    <div v-if="showList" class="mt-4">
        <div class="d-flex w-100 justify-content-between">
            <div class="d-flex align-items-center " style="column-gap: 0.8rem">
                <CSelectNew @input="onSort" v-model="query.sort" :options="sortOptions" :itemValue="'id'"
                    :itemText="'name'" class="py-0 sort-select"></CSelectNew>
                <div class="search-container position-relative" style="width: 400px">
                    <CInput class="search-bar" @input="searchWithDebounce" :placeholder="'Search by schedule name'"
                        :type="'text'"></CInput>
                    <v-icon small class="bg-white position-absolute p-2" style="right: 0.5rem; top: 4px"
                        color="rgba(79, 79, 79, 1)">mdi-magnify</v-icon>
                </div>
                <div class="filter"  >
                    <v-menu content-class="scheduled-report-filter-menu" min-width="300px" bottom
                        :close-on-content-click="false"  nudge-bottom="35px">
                        <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex justify-content-between align-items-center" role="button"
                                v-bind="attrs" v-on="on">
                                <span class="mr-2">Filter</span>
                                <v-icon color="#BDBDBD" small>mdi-chevron-down</v-icon>
                            </div>
                        </template>
                        <div class="bg-white" style="width: 370px;">
                            <div class="font-weight-bold px-3 py-2 mb-3">Filter</div>

                            <div class="mb-3 px-3">
                                <p class="m-0 mb-2"><b>Status</b></p>
                                <div>
                                    <input class="mr-2" v-model="allValue.status" @input="onClearArray('status')"
                                        type="checkbox" :value="'true'" />
                                    <label>All</label>
                                </div>
                                <div v-for="stat in statusOptions" :key="stat.id">
                                    <input class="mr-2" @input="onClearAllValue('status')" type="checkbox"
                                        :value="stat.id" v-model="filter.status" />
                                    <label>{{ stat.name }}</label>
                                </div>
                            </div>

                            <div class="author mb-3 px-3" id="created-by-filter">
                                <span class="mb-2 font-weight-bold d-block">Created by</span>
                                <v-autocomplete v-model="filter.created_by_id" :items="members"
                                    :search-input.sync="searchMember"
                                    :menu-props="{ attach: true }"
                                    item-value="id"
                                    item-text="name" label="Search" append-icon="mdi-magnify" solo dense flat
                                    color="#007BFF" item-color="#007BFF"
                                    hide-details hide-no-data multiple small-chips deletable-chips cache-items
                                    @update:search-input="" @change="searchMember = ''"></v-autocomplete>
                            <v-divider color="#D7D7D7" class="ma-0"></v-divider>

                            </div>

                            <div class="mb-3 px-3">
                                <span class="mb-2 font-weight-bold d-block">Category Report Template</span>
                                <CSelect v-model="filter.category_report_template" :options="categoryOptions"
                                    :itemValue="'value'" :itemText="'label'" class="py-0"></CSelect>
                            </div>

                            <div class="mb-3 px-3">
                                <span class="mb-2 font-weight-bold d-block">Report Template</span>
                                <CSelect v-model="filter.report_template_id" :options="reportTemplateOptionsWithAll"
                                    :itemValue="'id'" :itemText="'name'"
                                    :disabled="!filter.category_report_template || filter.category_report_template === 'all'"
                                    class="py-0"></CSelect>
                            </div>

                            <hr style="border: 1px solid #D7D7D7;" class="ma-0" />
                            <div class="d-flex action justify-content-between p-3">
                                <CButton @click.native="clearAdditionalFilter" :outline="true" :color="'#007BFF'"
                                    label="Clear">
                                </CButton>
                                <CButton @click.native="applyFilter" :color="'#007BFF'" label="Apply">
                                </CButton>
                            </div>
                        </div>
                    </v-menu>
                </div>
            </div>
            <div class="create-btn">
                <a href="/dashboard/scheduled_report/new">
                    <button class="btn btn-outline-primary d-flex align-items-center">
                        <v-icon small color="#007BFF" class="mr-1">mdi-plus</v-icon>
                        New Schedule Report
                    </button>
                </a>

            </div>
        </div>
    </div>
    <div v-if="showList" class="my-4">
        <ReportListTable :key="null" :items="scheduleReports" :headers="headers"
            :perPage="reportPagination.per_page" :totalItems="reportPagination.total_count"
            @loadPerPage="loadPerPage" @loadData="loadData" @reloadData="reloadData" @showBanner="showBanner" />
    </div>
    <ScheduledReportEmptyState v-else-if="showEmptyState" />
</div>
</div>

